import React, { useState, useEffect } from "react";
import AdminDashboard from "./AdminDashboard";
import { useAuth } from "react-oidc-context";

const API_URL = "https://btmw1l4cu9.execute-api.us-east-1.amazonaws.com/prod/leads";

const AdminPage = () => {
  const auth = useAuth();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Leads
  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const token = auth.user?.id_token;
        const res = await fetch(API_URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        setLeads(data.leads || []);
      } catch (err) {
        console.error("Failed to fetch leads:", err);
      } finally {
        setLoading(false);
      }
    };

    if (auth.isAuthenticated) {
      fetchLeads();
    }
  }, [auth.isAuthenticated, auth.user]);

  // Check Stripe Subscription
  useEffect(() => {
    const checkUserSubscription = async () => {
      try {
        const res = await fetch(
          "https://dgg5joe5f9.execute-api.us-east-1.amazonaws.com/prod/check-subscription",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: auth.user?.profile?.email }),
          }
        );

        const data = await res.json();
        setIsSubscribed(data.subscribed);
        setSubscriptionId(data.subscriptionId);
      } catch (err) {
        console.error("Subscription check failed:", err);
      }
    };

    if (auth.isAuthenticated) {
      checkUserSubscription();
    }
  }, [auth.isAuthenticated, auth.user?.profile?.email]);

  // const handleSubscribe = async () => {
  //   try {
  //     setLoading(true); // Show spinner
  //     const res = await fetch(
  //       "https://2fqip35f6h.execute-api.us-east-1.amazonaws.com/prod/create-checkout-session",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ email: auth.user?.profile?.email }),
  //       }
  //     );

  //     const data = await res.json();
  //     if (data.url) {
  //       window.location.href = data.url; // Redirect in same window
  //     } else {
  //       alert("Failed to start checkout session.");
  //       setLoading(false); // Stop spinner on failure
  //     }
  //   } catch (err) {
  //     console.error("Subscription error:", err);
  //   }
  // };

  

  return (
    <AdminDashboard
      isSubscribed={isSubscribed}
      subscriptionId={subscriptionId}
      setIsSubscribed={setIsSubscribed}
      setSubscriptionId={setSubscriptionId}
      leads={leads}
      loading={loading}
    />
  );
};

export default AdminPage;
